import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CreditOrderSearchModel} from "../credit-order-search.model";
import {CreditOrderEntityModel} from "../credit-order-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {CreditOrderReportModel} from "../../reports/credit-order-report/credit-order-report.model";

@Component({
    selector: "wbo-credit-order-search-page",
    templateUrl: "./credit-order-search-page.component.html",
    providers: [provideSearchModel(CreditOrderSearchModel), provideEntityModel(CreditOrderEntityModel), provideReportModel(CreditOrderReportModel)]
})
export class CreditOrderSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
